var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"md-activity-indicator-spinning",class:{dark: _vm.color === 'dark'}},[_c('md-icon',{staticClass:"md-activity-indicator-svg",style:({width: (_vm.size + "px"), height: (_vm.size + "px")}),attrs:{"name":"spinner"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-230aa981","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/vxmobile/components/activity-indicator/spinner.vue
// module id = null
// module chunks = 